module.exports = __webpack_public_path__ + "img/wechatSeller.d4d51e97.png";